import styled from '@emotion/styled';
import { Link as unstyledLink } from 'react-router-dom';
import unstyledBackIcon from '@material-ui/icons/ArrowBack';
import COLORS from '$variables/colors';
import { spacing, contextBarHeight } from '$variables/theme';

export const ContextBarContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0px;
  z-index: 1; // to fix; student Avatars were overlapping the contextbar
  background: ${COLORS.white};
  border-bottom: 1px solid ${COLORS.shadow2};
`;

export const ContextBar = styled.div`
  width: 100%;
  height: ${contextBarHeight};
  display: flex;
  flex-shrink: 0;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  padding: ${spacing.xSmall} ${spacing.small};
`;

export const LeftContent = styled.div`
  display: flex;
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
`;

export const PreviousPageTitle = styled.div`
  color: ${COLORS.navyBlue};
  display: flex;
  align-items: center;
  margin-left: ${spacing.small};
`;

export const Link = styled(unstyledLink)`
  color: ${COLORS.default};
  background-color: ${COLORS.oliveBg};
  height: 32px;
  width: 32px;
  border-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${COLORS.grey4};
  }
`;

export const BackIcon = styled(unstyledBackIcon)`
  height: 20px;
  width: 20px;
`;
